import fetchJsonp from "fetch-jsonp";
export var cart = function cart(apiBase) {
  return fetchJsonp("".concat(apiBase, "/cart/cart.json"), {
    cache: "no-cache",
    credentials: "include"
  });
};